export enum ClaraEntryPoint {
  BONUS_LIST = "bonus_list",
  BONUS_DETAIL = "bonus_detail",
  NAVIGATION_BUTTON = "navigation_button",
}
